var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnailVideoPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "328px",
    height: "185px",
    viewBox: "0 0 328 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "328px",
    height: "185px",
    fill: "none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1959_203514",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 53,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2786 0L38.5078 0.00906338C40.0205 0.129155 41.2214 1.42755 41.2214 2.99987V13.5002L53 1.50071V34.5008L41.2214 22.4998V33.0017L41.2125 33.2349C41.0946 34.7751 39.8204 36 38.2786 36H2.94428L2.71512 35.9909C1.20223 35.8707 0 34.571 0 33.0017V2.99987L0.00890526 2.76619C0.126899 1.22352 1.40254 0 2.94428 0H38.2786Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1959_203514)",
    transform: "translate(131.98, 63.875)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5.52075 41.6264H58.5207V-5.625H-5.52075V41.6264Z",
    fill: "#737373"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailVideoPlaceholder);
export default __webpack_public_path__ + "static/media/thumbnail-video-placeholder.1aa8bc7a35c30654db0b63f5a330fdab.svg";
export { ForwardRef as ReactComponent };